import { Permission } from 'shared/types/models';

export const roleUrls = {
  [Permission.dealer]: '/dashboard',
  [Permission.admin]: '/admin',
  [Permission.user]: '/',
  [Permission.sales]: '/',
};
